import { useRouter } from 'next/router';
import { useQuery } from 'react-query';

import { getChartFilterFromQuery } from '@/page-src/chart/utils/get-chart-filter-from-query';
import { getUseQueryDataUndefinedErrorMessage } from '@/page-src/prequalification/pages/loans/utils/error-message';
import { getComparableDeposits } from '@/page-src/product/pages/deposits/api';
import { useSavingsProductGuidContext } from '@/src/@domain/savings/hooks/use-savings-guid-context';
import { getSavingsRequestFilters } from '@/src/@domain/savings/utils/get-request-filters';
import { API_PATH } from '@/src/constants/api-path';

export const useGetDeposits = () => {
  const { query } = useRouter();
  const productGuid = useSavingsProductGuidContext();

  const primeRateConditionTypes = getChartFilterFromQuery<string[]>(
    query,
    'prime-rate-condition',
    []
  );

  const month =
    query['registration-months'] !== undefined ? Number(query['registration-months']) : undefined;

  const parsedPrimeRateConditions = getSavingsRequestFilters(primeRateConditionTypes, true);

  const { data } = useQuery([API_PATH.GET_COMPARABLE_DEPOSIT(productGuid)], () =>
    getComparableDeposits(productGuid, {
      registrationMonths: month,
      savingsPrimeRateConditionTypeEnums: parsedPrimeRateConditions,
      productGuid,
      isAllPrimeRateEnabled: primeRateConditionTypes.length === 0,
    })
  );

  if (data === undefined) {
    throw new Error(getUseQueryDataUndefinedErrorMessage(getComparableDeposits.name));
  }

  const { deposit } = data.result;

  const isValidProduct = deposit.isExposable && !deposit.isStopped;

  return {
    result: data.result,
    isValidProduct,
  };
};
